<template>
	<div>
		<div class="search">
			<div class="block">
				<el-date-picker
					v-model="timer"
					:default-time="['00:00:00', '23:59:59']"
					value-format="timestamp"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					clearable
					style="width: 400px;"
				></el-date-picker>
			</div>
			<div class="block">
				<el-select v-model="billType" placeholder="请选择卡类型">
					<el-option label="全部" value=""></el-option>
					<el-option label="实体卡" :value="2"></el-option>
					<el-option label="虚拟卡" :value="1"></el-option>
				</el-select>
			</div>			
			<div class="block"><el-button type="primary" @click="getDate()">搜索</el-button></div>
		</div>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" height='calc(100vh - 250px)'>
			<el-table-column type="index" label="序号"></el-table-column>
			<el-table-column label="出单时间">
				<template slot-scope='scope'>
					<span>{{setTime(scope.row.detail.createAt)}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="product.name" label="商品"></el-table-column>
			<el-table-column prop="detail.name" label="购买用户"></el-table-column>
			<el-table-column prop="detail.nationalId" label="证件号"></el-table-column>
			<el-table-column label="付款金额">
				<template slot-scope='scope'>
					<span class="yellow">{{scope.row.detail.amount/100}} 元</span>
				</template>
			</el-table-column>
			<el-table-column label="流水金额">
				<template slot-scope='scope'>
					<span class="yellow">{{scope.row.cutAmount/100}} 元</span>
				</template>
			</el-table-column>
			<el-table-column label="服务起始日期">
				<template slot-scope='scope'>
					<span>{{setTime(scope.row.detail.validFrom)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope='scope'>
					<router-link v-if='scope.row.detail.billType == 1' class='blue' :to="{path:'/financial/yesSettlement/financialDetails?',query:{id:scope.row.detail.billingId}}">查看详情</router-link>
					<router-link v-else class="blue" :to="{path:'/financial/cardorderDetail1',query:{id:scope.row.detail.billingId}}">查看详情</router-link>
				</template>
			</el-table-column>
		</el-table>
		<div class="fenye">
			<pages class='pagination' :allpage='allpage' :changePage='changePage'></pages>
		</div>
	</div>
</template>

<script>
	import { settleOrderlist } from '@/axios/api.js';
	import common from '@/assets/common.js';
export default {
	data() {
		return {
			timer: '',
			tableData: [],
			allpage:10,
			billType:''
		};
	},
	methods: {
		setTime(str) {
			return common.time(str);
		},		
		changePage(start,count){
			this.getDate(start,count)
		},
		getDate(start,count) {
			var data={
				start:start||0,
				count:count||10,
				billType:this.billType
			}
			if(this.timer){
				data.startts=this.timer[0];
				data.endts=this.timer[1];
			}
			settleOrderlist(data)
			.then(res => {
				this.tableData=res.data.obj;
				this.allpage=res.data.obj2;
			})
			.catch( err => {
				console.log(err)
			})
		},
	},
	mounted(){
		this.getDate()
	}
};
</script>

<style scoped="scoped">
.search {
	overflow: hidden;
	margin-top: 20px;
}

.search .block {
	float: left;
	margin-right: 10px;
}

.sss {
	width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/allowList.vue